import { createNumberMask } from '@optimus-web/core';
import { processError } from '../validation';
import { InputField } from './Input';

const handleChange = (onChange: $TSFixMe) => (e: $TSFixMe, value: $TSFixMe) => {
    if (onChange) {
        const actualValue = value || e.currentTarget.value;
        onChange(actualValue);
    }
};

// @ts-expect-error $TSFixMeError: Argument of type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to parameter of type 'ComponentTy...
const MaskedNumberInput = createNumberMask(InputField);

const NumberInput = ({ onChange, ...other }: $TSFixMe) => (
    <MaskedNumberInput onChange={handleChange(onChange)} {...other} />
);

export default processError(NumberInput);
